import React from 'react';

/**
 * Full-width crisis bar.
 */
const QuoteSection = () => {
  return (
    <section style={{ backgroundColor: 'var(--crisis-red)' }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4" style={{ maxWidth: '1280px' }}>
        <p className="text-center text-white font-semibold">
          In crisis? Call 988 or text HOME to 741741
        </p>
      </div>
    </section>
  );
};

export default QuoteSection;
